import { useContext, useEffect, useState } from 'react';
import SegmentationFiltersInstanceContext from '../state/SegmentationFiltersInstanceContext';
export const MEDIA_SIZES = {
  sm: 'sm',
  md: 'md',
  lg: 'lg'
};
export const MEDIA_SIZES_WIDTH = {
  [MEDIA_SIZES.sm]: 800,
  [MEDIA_SIZES.md]: 1000,
  [MEDIA_SIZES.lg]: 1200
};
const getMediaSizeWidth = width => {
  if (width <= MEDIA_SIZES_WIDTH.sm) {
    return MEDIA_SIZES.sm;
  }
  if (width <= MEDIA_SIZES_WIDTH.md) {
    return MEDIA_SIZES.md;
  }
  return MEDIA_SIZES.lg;
};
export const useElementSize = () => {
  const {
    filtersContainerRef
  } = useContext(SegmentationFiltersInstanceContext);
  const [width, setWidth] = useState(0);
  useEffect(() => {
    const target = filtersContainerRef === null || filtersContainerRef === void 0 ? void 0 : filtersContainerRef.current;
    const handleResize = () => {
      if (target) {
        setWidth(target.getBoundingClientRect().width);
      }
    };
    handleResize();
    if (target) {
      new ResizeObserver(handleResize).observe(target);
    }
  }, [filtersContainerRef]);
  return {
    width: {
      dimension: width,
      size: getMediaSizeWidth(width)
    }
  };
};